import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import {
  Chat,
  ChatMessageSendEvent
} from '@progress/kendo-react-conversational-ui';
import { ChatState } from '../../types/state/websocket/chat-state';

export interface FasilitatorChatProps {
  item?:
    | {
        id: string;
        name: string;
        type: 'global-chat' | 'player-chat' | 'team-chat' | 'group-chat';
      }
    | undefined;
  messages?: ChatState[];
  onSendMessage?: (message: string) => void;
  className?: string;
}

export const FacilitatorChat = ({
  onSendMessage = () => {},
  ...props
}: FasilitatorChatProps) => {
  const [messages, setMessages] = useState<ChatState[]>([]);
  const auth = useAuth();
  const userId = parseInt(auth?.user?.profile.sub!);
  const user = {
    id: userId?.toString(),
    avatarUrl:
      'https://demos.telerik.com/kendo-ui/content/web/Customers/RICSU.jpg'
  };
  const addNewMessage = (event: ChatMessageSendEvent) => {
    if (event?.message?.text) {
      onSendMessage(event?.message?.text);
    }
  };

  useEffect(() => {
    if (props.messages) {
      setMessages(props.messages);
    }
  }, [props?.messages]);

  return (
    <div
      className={'d-flex flex-column gap-2 h-100 facilitator-chat-container'}>
      <h3 className={'text-dark p-0 m-0'}>
        <b>{props?.item?.name}</b>
      </h3>
      <Chat
        user={user}
        messages={messages}
        onMessageSend={addNewMessage}
        placeholder={'Type a message...'}
        className={`flex-grow-1 w-100 ${props.className}`}
      />
    </div>
  );
};
